import { render } from "./TabsNavigation.vue?vue&type=template&id=7aa0d5b2&scoped=true"
import script from "./TabsNavigation.vue?vue&type=script&lang=js"
export * from "./TabsNavigation.vue?vue&type=script&lang=js"

import "./TabsNavigation.vue?vue&type=style&index=0&id=7aa0d5b2&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa0d5b2"]])

export default __exports__